module.exports = __webpack_public_path__ + "static/media/iconfinder_NEGATIVE_microphone_mic_record_micro_2848306.4f8307e4.svg";